
const numToFixed = function(num) {
  return Number(num).toFixed(2)
}
export default numToFixed
